var _jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Mobile/HelpCenterMenu.js",
  _this = this;
import React from 'react';
import Menu from './components/Menu';
import { mobileHelpCenterMenu } from '../../config/linkInfo.js';
export var HelpCenterMenu = function HelpCenterMenu() {
  return /*#__PURE__*/React.createElement(Menu, Object.assign({}, mobileHelpCenterMenu(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7,
      columnNumber: 10
    }
  }));
};
export default HelpCenterMenu;
//# sourceMappingURL=HelpCenterMenu.js.map